import NaptimeResource from './NaptimeResource';

class OnDemandWidgetSessionsV1 extends NaptimeResource {
  static RESOURCE_NAME = 'onDemandWidgetSessions.v1';
}

export default OnDemandWidgetSessionsV1;
